import React from "react";

import styles from "./OfferContents.module.scss";
import { genOfferTypeText } from "../../../utils/GeneralUtils";

type Props = {
  offer_type?: string;
  contents?: string;
  other_reason?: string;
};

const OfferContents: React.FC<Props> = (props) => {
  const { offer_type, contents, other_reason } = props;

  return (
    <div className={styles["f-adminOfferContent"]}>
      <h2 className={styles["f-adminOfferContent__title"]}>オファー内容</h2>
      <div className={styles["f-adminOfferContent__content"]}>
        <div className={styles["f-adminOfferContent__content-label"]}>
          オファー種別
        </div>
        <div className={styles["f-adminOfferContent__content-type"]}>
          {offer_type !== "5" ? genOfferTypeText(offer_type) : other_reason}
        </div>
        <p>{contents}</p>
      </div>
    </div>
  );
};

export default OfferContents;
